"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shipError = exports.configure = void 0;
const core_utility_1 = require("@built/core-utility");
const logging_1 = require("../logging");
// as of writing, DD logs is about 18KB download
// we do not want to bundle that or otherwise wait during normal initialization, where authenticated session is expected
// we will lazy load this script to avoid the extra download for the majority of users
// however, we are using CDN, so it should be relatively fast and cached some part of the time..
const LOG_NAMESPACE = 'DD_LOGS'; // this is hardcoded by DD, but just pulling it here for clarity
const LOG_SCRIPT_URL = 'https://www.datadoghq-browser-agent.com/us1/v4/datadog-logs.js';
const prodEnvs = ['prod', 'demo', 'dim1', 'pmu'];
const getDefaultClientToken = (env) => {
    if (prodEnvs.includes(env)) {
        return 'pub446b76bbf5796e964e004c445019d180';
    }
    return 'pub4e82fa4593370c5bf3caeb20ac6c5097';
};
const typedGlobalThis = globalThis;
const q = [];
let logNs;
/** Use inside of onReady callbacks to get fully-assembled logging namespace object. */
const getLogNs = () => logNs;
/** Ensure that logging is initialized (to download and call registered onReady funcs when done). */
const ensureLoggingReady = (remoteConfig = config === null || config === void 0 ? void 0 : config.authentication.logging) => {
    if (logNs) {
        return logNs;
    }
    // initialize queue
    typedGlobalThis[LOG_NAMESPACE] = logNs = {
        q,
        onReady: (f) => {
            q.push(f);
        },
    };
    if (!remoteConfig) {
        // this should only happen in cases where `shipError` is used outside of regular app-auth-utility use
        // normally it will be configured as part of app-auth-utility initialization
        // we do this to support using it as a general purpose remote logging utility where monitoring-utility is not used/initialized
        (0, logging_1.warn)('No remote logging configuration provided. Remote logging disabled. Need to pass `remoteConfig` in `shipError` options.');
        return logNs;
    }
    try {
        // download logs script dynamically
        (0, logging_1.verbose)(`Downloading logging support from: '${LOG_SCRIPT_URL}'`);
        const script = document.createElement('script');
        script.src = LOG_SCRIPT_URL;
        document.head.appendChild(script);
        logNs.onReady(() => {
            var _a, _b, _c;
            logNs = typedGlobalThis[LOG_NAMESPACE]; // update to fully constructed object
            const loggingConfig = {
                clientToken: remoteConfig.clientToken,
                site: 'datadoghq.com',
                service: (_b = (_a = remoteConfig.app) === null || _a === void 0 ? void 0 : _a.id.replace('@', '').replace('/', '-')) !== null && _b !== void 0 ? _b : window.location.hostname.split('.')[0] + '-auth',
                version: (_c = remoteConfig.app) === null || _c === void 0 ? void 0 : _c.version,
                forwardErrorsToLogs: false, // we want to scope this error reporting to auth utility; RUM has its own handling
            };
            (0, logging_1.verbose)('Initializing logging support.', loggingConfig);
            const init = getLogNs().init;
            init(loggingConfig);
        });
    }
    catch (ex) {
        (0, logging_1.error)('Error setting up remote logging.', remoteConfig, ex);
    }
    return logNs;
};
let config;
/** Configures remote logging. */
const configure = (authConfig) => {
    if (!authConfig.authentication.logging) {
        const defaultConfig = {
            adapter: 'datadog',
            clientToken: getDefaultClientToken(authConfig.env),
        };
        (0, logging_1.verbose)('Using default remote logging configuration.', defaultConfig);
        authConfig.authentication.logging = defaultConfig;
    }
    else {
        (0, logging_1.verbose)('Configuring remote logging.', authConfig.authentication.logging);
    }
    config = authConfig;
};
exports.configure = configure;
/**
 * Ship an error to remote logging.
 *
 * NOTE: This should only be used in cases where monitoring-utility has not been initialized.
 * It is preferred to use its track/shipError if it has been initialized.
 */
const shipError = (message, options = {}) => {
    const logs = ensureLoggingReady(options.remoteConfig);
    logs.onReady(() => {
        try {
            (0, logging_1.verbose)('Shipping error.', { message, options });
            getLogNs().logger.error(message, (0, core_utility_1.removeUndefined)(options.context), options.exception);
        }
        catch (ex) {
            (0, logging_1.error)('Error shipping error to remote logging.', { message, options }, ex);
        }
    });
};
exports.shipError = shipError;
